import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {AssetMoudleIcon} from '@csrc/assets/icons'

export const assetNavigation = [
	{
		id: 'sst.assets',
		title: 'asset.nav.assets',
		icon: <FontAwesomeIcon icon={AssetMoudleIcon}/>,
		navLink: '/assets',
		action: 'call',
		resource: 'SST_VIEW_ASSET',
		omit: false
	}
]
